var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83325 22.6667C2.83325 18.6604 2.83325 16.6558 4.0785 15.412C5.32234 14.1667 7.32692 14.1667 11.3333 14.1667H22.6666C26.6729 14.1667 28.6775 14.1667 29.9213 15.412C31.1666 16.6558 31.1666 18.6604 31.1666 22.6667C31.1666 26.6731 31.1666 28.6777 29.9213 29.9215C28.6775 31.1667 26.6729 31.1667 22.6666 31.1667H11.3333C7.32692 31.1667 5.32234 31.1667 4.0785 29.9215C2.83325 28.6777 2.83325 26.6731 2.83325 22.6667Z",
    stroke: "#344054",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.1667V11.3334C8.49796 9.26306 9.25158 7.26317 10.6194 5.70908C11.9873 4.15498 13.8753 3.15354 15.9291 2.8927C17.9829 2.63187 20.0613 3.12958 21.7742 4.29242C23.4871 5.45526 24.7167 7.20327 25.2323 9.20837",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 22.6667H11.346M16.9872 22.6667H16.9999M22.6538 22.6667H22.6666",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.3849a011c4ede2a9fad01e32bd99bff1.svg";
export { ForwardRef as ReactComponent };